import "./src/styles/global.scss";
import Wrapper from "./src/wrapper";
export const wrapPageElement = Wrapper;

export function onRouteUpdate() {
    // wrap inside a timeout to ensure the title has properly been changed
    setTimeout(() => {
        const data = window["dataLayer"] || [];
        data.push({ event: `gatsby-route-change` });
    }, 50);
}
